<template>
  <v-container class="web_home_style" height="70vh">
      <v-flex xs5 class="elevation-2 mx-auto containerBackground" style="height: 30vh">
        <v-layout align-center justify-center column fill-height>
        <v-progress-circular
          :size="70"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
        </v-layout>
      </v-flex>
  </v-container>
</template>


<script>
import Router from "vue-router";
import appConfig from "../../config/app_config";
import UserObject from "../objects/UserObject.js";
import * as dssRequest from "../api/dssRequest";
import { store } from "../store";
import BaseComponent from "./base/BaseComponent.vue";
import BaseObject from "../objects/BaseObject";

export default {
  name: 'User_Activation',
  extends: BaseComponent,
  components: {
  },
  created() {
  },
  mounted() {
    this.confirmRegistration();
  },
  data() {
    return {
      e4: true,
      valid: true,
      loading: false,
      eventData: "",
      arrivalInfo: "",
      loginSuccess: false,
      activateObj: {}
    };
  },
  methods: {
    confirmRegistration() {
      console.log("Brian this.$route.query", this.$route.query);

      this.activateObj = {};
      const userID = this.$route.query.UserID;
      store.commit("auth/setUserName", userID);
      const email = this.$route.query.email;
      const passwordHash = this.$route.query.token;
      const type = this.$route.query.type;
      const goTo = this.$route.query.goTo;
      const partnerId = this.$route.query.hasOwnProperty('PartnerId') ? this.$route.query.PartnerId : -1;
  console.log("partnerId partnerId partnerId", this.partnerId)
      this.activateObj = UserObject._createActivateUserObject(
        appConfig.login.clientSecret,
        email,
        userID,
        passwordHash,
        type,
        partnerId
      );

      dssRequest.doRequest(
        response => {
          if (response.value === 1) {
            store.commit("auth/setToken", response.data.access_token);
            store.commit("auth/setRefreshToken", response.data.refresh_token);
            this.activateObj.password = passwordHash;
            console.log("activateOBJ", this.activateObj);
            if (this.activateObj.hasOwnProperty('PartnerId') && this.activateObj.PartnerId !== null && this.activateObj.PartnerId > -1) {
              this.$store.commit('setSavePartnerId', Number(this.activateObj.PartnerId));
              this.$store.commit("setRedirectedFromPearlCalendar", true);
              this.activateObj.PartnerId = Number(this.activateObj.PartnerId);
            }
            this.$store.commit("setUserActivationObject", this.activateObj);
            let userLogin = BaseObject._toLowerCaseObjectProperties(
              this.activateObj
            );

            userLogin.password = this.userName;
            let loginUser = new UserObject(
              userLogin.client_id,
              userLogin.email,
              "u",
              userLogin.password
            );
            loginUser.userlogin(
              response => {
                this.$store.commit("setUserActivatedSuccessfull", true);
                console.log("Brian goTo", goTo);
                if (goTo !== '' && goTo !== null && goTo !== undefined) {
                  let search = goTo.search(':') + 1;
                  this.goTo("ActivityDetailScreen", { event_id: goTo.substring(search) });
                } else {
                  this.goTo("Homepage");
                }
              },
              error => {
              }
            );

            // this.$router.push({
            //   name: "Login",
            //   params: {
            //     type: 'u',
            //     account_id: this.$store.getters.getRegion,
            //     data: this.activateObj
            //   }
            // })

            //   console.log("ok pushing to Calendar", this.activateObj)
            //   this.$router.push({
            //     name: "Calendar",
            //     params: {
            //       type: 'u',
            //       account_id: this.currentAccountId,
            //       partner_id: this.activateObj.PartnerId,
            //       data: this.activateObj
            //     }
            //   })
            // } else {
            //   console.log("ok NOT pushing to Calendar", this.activateObj)

            // this.$router.push({
            //   name: "Home",
            //   params: {
            //     type: 'u',
            //     account_id: this.currentAccountId,
            //     data: this.activateObj
            //   }
            // });
            // }
          }
        },
        error => {
        },
        "activateUser",
        store.getters.getCurrentAccountId,
        this.activateObj
      );
    },
    goTo(page, params = "component") {

      // Generic function to let the user move to other component
      this.$router.push({
        name: page,
        params: params
      });
    },
    headerImage() {
      let fileType = ".png";
      let image = appConfig.mainImages.loginImage;
      return require("../assets/" + image + fileType);
    }
  }
};
</script>

<style scoped>
.greyBorder {
  border: 2px solid #c0c0c0 !important;
}

.listPadding {
  padding-left: 15px;
}
.fontWeight {
  font-weight: normal !important;
}
.navButtons {
  font-size: 2em;
  width: 100%;
  height: 100px;
  margin: 0px;
  border-radius: 0px;
  box-shadow: none !important;
  outline: 5px solid white;
}
.maxText {
  max-width: 850px !important;
}
.web_home_style {
  width: auto;
  height: 85vh;
}
</style>
